import { FoodKosherIcon } from './FoodKosherIcon';

/**
 * author: Haley Halcyon
 * id BC887CBF-E298-4E05-8C7D-B13539C4BA15
 * name food-kosher
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/food-kosher.svg
 * tags
 * - Food / Drink 
 */
export const FoodJewishIcon = FoodKosherIcon;
export default FoodJewishIcon